import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetUserInfoQuery, useGetUserCompaniesQuery } from "../features/user/userApiSlice";

export const useJobsCompaniesState = () => {
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);

  const [showshare, setShowshare] = useState(0);
  const [show, setShow] = useState(0);

  const handleCloseshare = () => {
    setShowshare(0);
    setShow(1);
  };

  const handleClosemodal = () => {
    setShow(0);
  };

  const handleShowshare = () => {
    setShow(0);
    setShowshare(1);
  };

  // RTK Query calls — refetchOnMountOrArgChange picks up creates via tag invalidation
  const { data: companiesData, isLoading: companiesLoading } = useGetUserCompaniesQuery(
    { userid: name?._id, isJobsCompany: true },
    { skip: !name?._id, refetchOnMountOrArgChange: true }
  );

  const { data: userInfoData } = useGetUserInfoQuery(name?._id, {
    skip: !name?._id,
  });

  useEffect(() => {
    const category = companiesData?.data?.Companies?.[0]?.shopCategory;
    if (category) {
      localStorage.setItem("mycategory", category);
    }
  }, [companiesData]);

  return {
    navigate,
    name,
    JobsCompany: companiesData?.data?.Companies || [],
    isloading: companiesLoading,
    showshare,
    setShowshare,
    show,
    setShow,
    userimg: userInfoData?.data?.User?.imageUrl,
    handleCloseshare,
    handleClosemodal,
    handleShowshare,
  };
};
